import * as React from 'react'
import { getMetricScript } from '../../utils/csm'

// Because we're using dangerouslySetInnerHTML
// the Above The Fold (aka ATF or af) metric will correspond
// to the time before the react hydrate
const ATFMarker = () => {
  const content = { __html: `<script>${getMetricScript('af')}</script>` }
  return (<div dangerouslySetInnerHTML={content} />)
}

export default ATFMarker
